import React, {useEffect} from "react"
import { useSignal } from "@preact/signals-react"
import { Box, Stack, Typography } from "@mui/material"
import { ImageSeeker, ModalSeeker } from "@ui-seeker/core"


export default function ModalCarouselImagesSeeker({ isOpen, controller, multimedia = [], text=[], initPos=0, title="Images in Product", isVideo, ...props }) {
    const posImg = useSignal(initPos)

    useEffect(() => {
        posImg.value = initPos
    }, [initPos])

    const imageValue = multimedia || []
    const textValue = text || []

    return <ModalSeeker isOpen={isOpen} controller={controller} title={title} size="md" hideActions {...props}>
        <Stack sx={{alignItems: "center", rowGap: "1rem", ...props?.modalContent}}>
            <ImageSeeker src={imageValue[posImg.value]} sx={{maxWidth: '600px', maxHeight: '600px', ...props?.imageStyles}}/>
            {!!textValue.length && <Typography variant="h5" sx={{py: 2}}>
                {textValue[posImg.value]}
            </Typography>}
            <Stack direction="row" gap={1}>
                {imageValue.map((img, idx) => <Box component="span" key={idx}>
                    <ImageSeeker
                        src={img}
                        sx={{
                            width: 50, height: 50, cursor: "pointer",
                            ...posImg.value === idx && {border: "3px solid", borderColor: "info.main"}
                        }}
                        onClick={() => posImg.value = idx}
                    />
                </Box>)}
            </Stack>
        </Stack>
    </ModalSeeker>
}